<template>
  <div id="tab1">
    <!-- <div class="divider mgb-16"></div> -->
    <div
      class="pdl-16 pdr-16"
      @click.prevent="prizes.status == null ? moveToDetails(prizes.id) : ''"
      v-if="type == 'request'"
    >
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white">
        <div class="d-flex pdt-16 pdb-16 pdr-16 pdl-16">
          <div
            class="placeholderImage b-radius4 overflow-hidden position-relative"
            :class="prizes.status !== null ? 'soldout-image' : ''"
          >
            <img
              :src="
                prizes.thumbnail.resourceUri
                  ? prizes.thumbnail.resourceUri
                  : 'images/prize_request/placeholder72.png'
              "
              alt=""
            />
          </div>
          <div>
            <div
              class="pdl-16 mgb-14 t-subtitle2 l-spacing66 font-b"
              :class="
                prizes.status == null ? 't-color-title' : 't-color-content1'
              "
            >
              {{ prizes.name }}
            </div>
            <div class="d-flex align-items-center" v-if="prizes.status == null">
              <div class="pdr-3 t-body3 t-color-title">
                <span
                  class="listPointIcon d-flex justify-content-center align-items-center t-color-white bg-textField2 mgr-4 pdt-2 t-body4"
                  >P</span
                >
              </div>
              <div class="t-headline5 t-color-title d-flex align-items-center">
                <div class="mgr-8">
                  <img
                    src="images/prize_request/p-image.svg"
                    class="w-24 h-24"
                    alt=""
                  />
                </div>
                {{ prizes.price }}
              </div>
            </div>
            <div class="d-flex align-items-baseline" v-else>
              <div
                class="pdl-4 pdr-4 t-helper soldout-message mgl-16 t-color-white"
              >
                {{ $t("1970") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- History -->
    <div v-else @click.prevent="moveToHistoryDetails(prizes.id)">
      <div class="pda-default">
        <div class="t-helper t-color-gray2 d-flex align-items-center">
          <span>Prize</span>
        </div>
        <div class="t-body2 list-title">
          {{ prizes && prizes.product ? prizes.product.name : "" }}
        </div>
        <div class="t-body4 mgt-4 d-flex">
          <div
            class="t-color-title mgt-4 mgr-8"
            v-if="prizes && prizes.status"
          >
            {{ getPurchaseStatusText(prizes.status.value) }}
          </div>

          <div class="t-color-content1 mgt-4">
            {{ $moment(prizes.buyRequestDatetime).format("YYYY.MM.DD") }}
          </div>
        </div>
      </div>
      <hr class="divider" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["prizes", "type"],
  mounted() {},
  methods: {
    toggleMethod() {
      $(".rightToggler").click(function () {
        $(".toggle-menu").toggleClass("toggleX300");
      });
      $(".toggle-menu > div").click(function () {
        $(this).addClass("selected").siblings().removeClass("selected");
      });
    },
    moveToDetails(id) {
      this.$router.push({
        name: "PrizeRequestDetails",
        params: { prizeid: id },
      });
    },
    moveToHistoryDetails(id) {
      this.$router.push({
        name: "PurchaseHistoryDetails",
        params: { prizeid: id },
      });
    },
    getPurchaseStatusText(status) {
      const statusMap = {
        CHECKING_ORDER: this.$t("S20038"),
        COMPLETED: this.$t("S20039"),
        REJECT: this.$t("S20040"),
        APPROVED: this.$t("S20131"),
        MAIL_SENT: this.$t("S20133"),
      };
      // 상태값이 없는 경우 기본값 처리
      return statusMap[status] || '';
    },
  },
};
</script>


<style scoped>
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}
.tabs .indicator {
  background: #2d6dcc;
}
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.tabs .tab {
  width: 50%;
}
.rightToggler {
  cursor: pointer;
}
.toggle-menu {
  width: 112px;
  height: 208px;
  right: -2px;
  top: 24px;
  box-shadow: 0 10px 13px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(206, 218, 220, 0.5);
  transition: all 300ms ease-in-out;
}
.toggle-menu > div {
  cursor: pointer;
  color: rgba(129, 129, 129, 0.87) !important;
}

.toggle-menu > div.selected,
.toggle-menu > div:hover {
  color: rgba(0, 0, 0, 0.87) !important;
}
.toggleX300 {
  transform: translateY(-500px);
}
.placeholderImage {
  min-width: 72px;
  height: 72px;
}
.placeholderImage img {
  width: 72px;
  height: 72px;
}
.soldout-message {
  background: #b0b5bc;
  border-radius: 2px;
  margin-top: -10px;
  letter-spacing: 1.2px;
}
.placeholderImage.soldout-image:after {
  position: absolute;
  content: "SOLDOUT";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  transform: rotate(-24deg);
  color: #fff;
  letter-spacing: 1.2px;
}
.placeholderImage.soldout-image:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
}
</style>